module.exports = __webpack_public_path__ + "static/media/04.7caee1df.jpg";